import qs from "qs";

import RolesApi from "../../services/api/Roles";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in roles actions:", err);
}

export const setRolesList = (payload) => {
  return {
    type: ActionTypes.SET_ROLES_LIST,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_ROLES,
    payload,
  };
};

export const setActionsList = (payload) => {
  return {
    type: ActionTypes.SET_ACTIONS_LIST,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_ROLES,
    payload,
  };
};

export const setActiveRole = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_ROLE,
    payload,
  };
};

export const bulkUploadRoles = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await RolesApi.bulkUploadRoles(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.FILE_UPLOAD_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const getRolesList =
  (filters = {}) =>
  async (dispatch) => {
    try {
      const finalPayload = qs.stringify(filters, { addQueryPrefix: true });
      dispatch(setLoader(true));
      let response = await RolesApi.getRolesList(finalPayload);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setRolesList(response));
        dispatch(
          setStatus({
            type: "success",
            message: SuccessMessages.LIST_RETRIEVAL_SUCCESS,
          })
        );
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getAllActions = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await RolesApi.getAllActions();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActionsList(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const getRolesActions = (role, roleName) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await RolesApi.getRolesActions(roleName);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setActiveRole({ ...response, name: roleName }));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateRole = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await RolesApi.updateRole(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    setStatus({
      type: "error",
      message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
    });
    handleError(err);
  }
};

export const addRoles = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await RolesApi.addRoles(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
